'use client';

import React from 'react';
import Footer, { Props as FooterProps } from 'components/commercetools-ui/organisms/footer';
import { FooterLink } from 'components/commercetools-ui/organisms/footer/atoms/column';
import { TasticProps } from '../types';
import { MarketProvider } from 'context/market';

interface Props extends FooterProps {
  data?: any;
}

const FooterTastic = ({ data }: TasticProps<Props>) => {
  const columns = data?.data?.dataSource?.navigation?.map((nav: { label: any; link: any }) => {
    return {
      header: nav?.label,
      links: nav?.link,
    };
  });
  return (
    <div className="fixed-screen-width lg:relative-width" style={{ borderTop: "1px solid #808080" }}>
      <MarketProvider>
        <Footer
          logo={data?.data?.dataSource?.logo?.url}
          columns={columns}
          socialMedia={data?.data?.dataSource?.social_media?.social_media_share}
          copyright={data?.data?.dataSource?.copyright}
        />
      </MarketProvider>
    </div>
  );
};

export default FooterTastic;
